const module = { name: 'movie/shared/mobile/cast', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_movieDetails } from 'require-core';

const { movieDetails } = Fandango_movieDetails;


import { fd_url_manager as link } from 'require-core';



import { default as castModal } from 'swug-fdRequire-call:movie/shared/castModal';



import { swig as swig } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



const Selectors = {
    CONTAINER: 'movie-details-person-container',
    CAROUSEL_WRAP: 'person-carousel-placeholder-wrap'
}


const Styles = {
    HIDE: 'hide',
}
function updateCastUI(err, people) {
    const carouselWrap = document.getElementById(Selectors.CAROUSEL_WRAP);
    if (err || !carouselWrap || !Array.isArray(people) || !people.length) {
        const container = document.getElementById(Selectors.CONTAINER);
        container?.classList.add(Styles.HIDE);
        return container && (container.innerText = '');
    }
    const markup = swig.render('_castCarousel', { people });
    carouselWrap.innerHTML = markup;
    castModal.attach({ root: carouselWrap });
}
function onDone(cb, data) {
    cb(!data, data);
}
function onFail(cb, err) {
    cb(true, err);
}
function attach(opts) {
    const { movieID: id = movieDetails.id, cb = updateCastUI } = opts || {};
    xhr.ajax({
        method: 'GET',
        url: link.napiMovieCast({ id }),
    })
        .done(onDone.bind(this, cb))
        .fail(onFail.bind(this, cb));
}
module.exports = {
    attach
};
export default module.exports;